export default __webpack_public_path__ + "static/media/ic_notif_success.cfb7547b.svg";